<section style="background-color: white; width: 100%;  height: calc(100vh - 50px)">

  <div style="display: flex; width: 100%;  justify-content: center; padding-top: 100px;">
    <img src="/assets/images/geral/logo_sbccv.png">
  </div>

</section>